import { HiShieldCheck } from "react-icons/hi";
import { MdCancel, MdAnalytics } from "react-icons/md";

const data = [
  {
    icon: <HiShieldCheck />,
    heading: "Unmatched Interest Rates",
    detail:
      "We offer the best interest rates in the market, ensuring that you get the maximum return on your investments.",
  },
  {
    icon: <MdCancel />,
    heading: "Protection Against Price Volatility",
    detail:
      "Our expert team helps you prevent losses due to unstable prices. With market monitoring and timely interventions.",
  },
  {
    icon: <MdAnalytics />,
    heading: "Comprehensive Market Analysis",
    detail:
      "We provide in-depth analytics and insights, empowering you with the data you need to make informed decisions.",
  },
];

export default data;
